import jump from 'jump.js'

export default function (context) {
  if (context.$store.state.showTicketSelection === false) {
    context.$store.commit('setShowTickets', true)
    context.$nextTick(function () {
      jump('#ticket-container', { duration: 500 })
    })
  } else {
    jump('#ticket-container', { duration: 500 })
  }
}
